<template>
  <div class="setup-plan-sokol">
    <div class="setup-plan-sokol__actions">
      <v-btn color="primary" class="text-none" rounded @click="savePlan()">
        <v-icon left>mdi-content-save-outline</v-icon>
        Сохранить
      </v-btn>
      <v-btn color="primary" outlined rounded class="text-none ml-2" @click.prevent="returnDoorphone()">
        <v-icon left>mdi-close</v-icon>
        Отменить
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="$checkPermission('import_rules')"
        color="primary"
        outlined
        class="text-none rounded"
        @click.stop="dialog = true"
      >
        <v-icon left>mdi-import</v-icon>
        Импортировать
      </v-btn>
      <v-btn v-if="canEdit" color="primary" class="text-none rounded ml-2" dark @click="addPlan">
        <v-icon left>mdi-plus</v-icon>
        Добавить
      </v-btn>
    </div>
    <v-dialog v-model="dialog" persistent max-width="570" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">Импортируя, вы сотрёте существующий план набора в базе данных.</v-card-title>
        <v-card-text>Подтверждая, вы импортируете квартиры и коды открытия с панели.</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" outlined class="text-none rounded" @click.prevent="dialog = false">Отменить</v-btn>
          <v-btn color="primary" class="text-none rounded" dark @click.prevent="importRulesData()">
            <v-icon left small>mdi-import</v-icon>
            Импортировать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      class="table mt-3"
      :headers="headers"
      :items="modifiedPlan"
      :disable-sort="true"
      :footer-props="{ showFirstLastPage: true }"
    >
      <template v-slot:item.Number="{ item }">
        <v-text-field
          v-model="item.Number"
          class="mt-4"
          solo
          outlined
          dense
          flat
          :disabled="!canEdit"
        />
      </template>
      <template v-slot:item.Phone1="{ item }">
        <v-text-field
          v-model="item.Phone1"
          class="mt-4"
          solo
          outlined
          dense
          flat
          :disabled="!canEditLogin"
        />
      </template>
      <template v-slot:item.DoorCode="{ item }">
        <v-text-field
          v-model="item.DoorCode"
          class="mt-4"
          solo
          outlined
          dense
          flat
          maxlength="5"
          :disabled="!canEdit"
        />
      </template>
      <template v-slot:item.Comment="{ item }">
        <v-text-field
          v-model="item.Comment"
          class="mt-4"
          solo
          outlined
          dense
          flat
          :disabled="!canEditComment"
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn v-if="canEdit" icon @click="deleteItem(item.Number)">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SetupPlanSokol',
  data () {
    return {
      modifiedPlan: [],
      dialog: false,
      canEdit: false,
      canEditLogin: false,
      canEditComment: false,
      headers: [
        { text: 'Номер квартиры', value: 'Number', align: 'center' },
        { text: 'sip логин', value: 'Phone1', align: 'center', sortable: false },
        { text: 'Код открытия', value: 'DoorCode', align: 'center', sortable: false },
        { text: 'Комментарий', value: 'Comment', align: 'center', sortable: false },
        { text: '', value: 'actions', align: 'center', sortable: false, width: '64px' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      recruitmentPlan: 'Doorphone/rules',
      roleName: 'roleName',
    }),
  },
  created () {
    this.loadPlan();
    switch (this.roleName) {
      case 'admin':
      case 'agent':
      case 'admin-engineer':
      case 'master':
        this.canEdit = true;
        this.canEditLogin = true;
        this.canEditComment = true;
        break;
      case 'manager':
        this.canEditLogin = true;
        this.canEditComment = true;
        break;
    }
  },
  methods: {
    ...mapActions({
      updateApartmentsBeward: 'Doorphone/updateApartmentsBeward',
      getRules: 'Doorphone/getRules',
      importRules: 'Doorphone/importRules',
    }),
    loadPlan () {
      this.getRules(this.$route.params.id)
        .then(() => {
          if (this.recruitmentPlan !== undefined) {
            this.modifiedPlan = JSON.parse(JSON.stringify(this.recruitmentPlan));
          }
        });
    },
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    deleteItem (number) {
      this.modifiedPlan = this.modifiedPlan.filter(plan => String(plan.Number) !== String(number));
    },
    addPlan () {
      const numbers = this.modifiedPlan.map(plan => Number(plan.Number)).filter(number => !Number.isNaN(number));
      const nextNumber = numbers.length ? Math.max(...numbers) + 1 : 1;
      this.modifiedPlan = [...this.modifiedPlan, {
        Number: String(nextNumber),
        Phone1: `${this.$route.params.id}_${nextNumber}`,
        Phone2: '',
        Phone3: '',
        Phone4: '',
        Phone5: '',
        PhonesActive: 'on',
        BlockCMS: 'off',
        DoorCode: this.randomDoorCode(),
        Comment: '',
      }];
    },
    randomDoorCode () {
      const used = this.modifiedPlan.map(row => String(row.DoorCode));
      let code = String(Math.floor(10000 + Math.random() * 90000));
      while (used.includes(code)) {
        code = String(Math.floor(10000 + Math.random() * 90000));
      }
      return code;
    },
    importRulesData () {
      this.importRules(this.$route.params.id)
        .then(() => {
          this.$flash_success('Импортирование успешно завершено');
          this.dialog = false;
          this.loadPlan();
        })
        .catch(() => {
          this.$flash_warning('Ошибка импортирования');
        });
    },
    savePlan () {
      if (!this.validatePlan()) {
        return;
      }
      const dataRules = this.modifiedPlan.map(row => ({
        Number: String(row.Number),
        Phone1: row.Phone1 || '',
        Phone2: row.Phone2 || '',
        Phone3: row.Phone3 || '',
        Phone4: row.Phone4 || '',
        Phone5: row.Phone5 || '',
        BlockCMS: row.BlockCMS || 'off',
        PhonesActive: row.PhonesActive || 'on',
        DoorCode: String(row.DoorCode),
        Comment: row.Comment || '',
      }));
      this.updateApartmentsBeward({ id: this.$route.params.id, rules: dataRules })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch((message) => {
          if (message && message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при смене плана набора');
          }
        });
    },
    validatePlan () {
      const codes = [];
      const numbers = [];
      for (let i = 0; i < this.modifiedPlan.length; i++) {
        const row = this.modifiedPlan[i];
        const number = String(row.Number ?? '').trim();
        if (!/^\d+$/.test(number) || Number(number) < 1 || Number(number) > 9999) {
          this.$flash_warning('Номер квартиры должен быть от 1 до 9999');
          return false;
        }
        if (numbers.includes(number)) {
          this.$flash_warning(`Квартира ${number} указана дважды`);
          return false;
        }
        numbers.push(number);
        const code = String(row.DoorCode ?? '').trim();
        if (!/^\d{5}$/.test(code)) {
          this.$flash_warning(`Квартира ${number}: код открытия должен быть из 5 цифр`);
          return false;
        }
        if (codes.includes(code)) {
          this.$flash_warning(`Код ${code} указан у нескольких квартир`);
          return false;
        }
        codes.push(code);
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.setup-plan-sokol__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
